import React from 'react';

const MobileHeaderOpener = ({toggleMenu,isMenuOpen}) => {
    return (
        <a role='button'  onClick={toggleMenu} className={`qodef-opener-icon qodef-m qodef-source--predefined qodef-mobile-header-opener ${isMenuOpen ? 'qodef--opened' : ''}`}>
            <span className="qodef-m-icon qodef--open">
                <span className="qodef-m-lines">
                    <span className="qodef-m-line qodef--1"></span>
                    <span className="qodef-m-line qodef--2"></span>
                    <span className="qodef-m-line qodef--3"></span>
                </span>
            </span>
            <span className="qodef-m-icon qodef--close">
                <span className="qodef-m-lines">
                    <span className="qodef-m-line qodef--1"></span>
                    <span className="qodef-m-line qodef--2"></span>
                    <span className="qodef-m-line qodef--3"></span>
                </span>
            </span>
        </a>
    );
};

export default MobileHeaderOpener;